import { lazy } from 'react'
import './locales'

export { default as ChatCreateButton } from './chat-create/ChatCreateButton' // used in storybook
export { CHAT_CREATE_EMPTY_TYPE, CHANNEL_TYPE } from './services/fsChat/fsChannelEnums'
export { CHAT_ROUTE_KEY, buildChatRoute } from './chat-memory-router/ChatMemoryRouter'
export { default as ChatProvider } from './providers/ChatProvider'
export { default as ChatOverlayButton } from './chat-overlay-button/ChatOverlayButton'
export { default as useHasUnreadChats } from './hooks/useHasUnreadChats'
export { default as useChatOverlay } from './hooks/useChatOverlay'
export { ChatContext } from './providers/useChatProviderContext'
export { generateChatUrl } from './helpers/chatLinkHelper'
// Lazy-loading is needed to prevent an import cycle that breaks the unit tests
export const EmbeddedChat = lazy(() => import('./embedded-chat/EmbeddedChat'))
EmbeddedChat.displayName = 'EmbeddedChat'
